import * as React from "react";

function Refresh(props) {
  return (
    <svg
      width={18}
      height={19}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3.1c1.795 0 3.335.809 4.355 2.25H10.5v1.5h5.25V1.6h-1.5v2.453C12.956 2.487 11.103 1.6 9 1.6a7.5 7.5 0 00-7.5 7.5H3a6 6 0 016-6zm0 12c-1.795 0-3.335-.809-4.355-2.25H7.5v-1.5H2.25v5.25h1.5v-2.453C5.044 15.713 6.897 16.6 9 16.6a7.5 7.5 0 007.5-7.5H15a6 6 0 01-6 6z"
      />
    </svg>
  );
}

export default Refresh;
